document.addEventListener('DOMContentLoaded', async () => {
  const section = document.querySelector('.account-gift-cards');
  if (!section) return;

  const container = section.querySelector('[data-gift-cards-container]');
  const endpoint = section.dataset.giftCardsEndpoint;

  const template = document.getElementById("giftcard-accordion-template");


  try {
    const res = await fetch(endpoint, { credentials: 'include' });
    const payload = await res.json();
    const giftcards = payload.gift_cards || [];

    container.innerHTML = "";

    if (!giftcards.length) {
      container.innerHTML = `<p class="text-center">No gift cards found.</p>`;
      return;
    }

    giftcards.forEach((card, index) => {
      const node = template.content.cloneNode(true);
      const details = node.querySelector("details");
      details.open = index === 0; // 只展开第一个

      node.querySelector("[data-last-characters]").textContent = card.lastCharacters;
      node.querySelector("[data-mask-code]").textContent = card.maskedCode;

      const statusEl = node.querySelector("[data-status]");
      statusEl.textContent = card.enabled ? "Active" : "Inactive";
      statusEl.classList.toggle("badge--active", card.enabled);
      statusEl.classList.toggle("badge--inactive", !card.enabled);


      node.querySelector("[data-balance]").textContent = "$"+card.balance;
      node.querySelector("[data-initial-value]").textContent = "$"+card.initialValue;
      node.querySelector("[data-created-at]").textContent = card.createdAt ? formatDatePT(card.createdAt) : "";
      node.querySelector("[data-expires-on]").textContent = handleExpiresOnDate(card.expiresOn, card.source);

      const transContainer = node.querySelector("[data-transaction-container]");
      const transList = transContainer.querySelector(".transactions");
      const transTemplate = node.querySelector("template[data-transaction-template]");

      transList.innerHTML = "";

      if (!card.transactions || !card.transactions.length) {
        transContainer.innerHTML = `<p class="text-center">No transactions.</p>`;
      } else {
        for (const trans of card.transactions) {
          const transNode = transTemplate.content.cloneNode(true);

          transNode.querySelector("[data-transaction-time]").textContent = trans.processedAt ? formatDateTimePT(trans.processedAt) : "";

          transNode.querySelector("[data-transaction-des]").textContent =
            trans.amount >= 0
              ? `Refunded +$${trans.amount}`
              : `Used -$${Math.abs(trans.amount)}`;

          transList.appendChild(transNode);
        }
      }

      container.appendChild(node);
    });

    
 


  } catch (err) {
    console.error(err);
    container.innerHTML = `<p class='text-center'>Failed to load gift cards.</p>`;
  }
});

document.addEventListener("click", (e) => {
  const infoBtn = e.target.closest(".info-icon");
  const allTooltips = document.querySelectorAll(".tooltip");

  // 先关掉所有 tooltip
  allTooltips.forEach(t => (t.style.display = "none"));

  if (!infoBtn) return;

  e.stopPropagation();

  const tooltipId = infoBtn.dataset.tooltipTarget;
  const tooltip = document.getElementById(tooltipId);

  if (tooltip) {
    tooltip.style.display = "block";
  }
});

// 点击 tooltip 本身不关闭
document.querySelectorAll(".tooltip").forEach(tooltip => {
  tooltip.addEventListener("click", e => e.stopPropagation());
});




// helper：
// 格式化日期
function formatDatePT(isoString) {
  return new Date(isoString).toLocaleDateString("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}


// 格式化时间
function formatDateTimePT(isoString) {
  const date = new Date(isoString);

  const datePart = date.toLocaleDateString("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  const timePart = date.toLocaleTimeString("en-US", {
    timeZone: "America/Los_Angeles",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  return `${datePart} · ${timePart.toLowerCase()}`;
}

// 处理expiresOn时间：
// 有过期时间则直接展示，没有过期时间的话，分为：1. 用户购买的，没有过期时间  2. 客服创建的若没有expiresOn则统一设置成2026年的6月30,美西时间,即"2026-07-01T06:59:59Z"
// source: node.order ? "purchased" : "manual",
function handleExpiresOnDate(isoString, source) {
  if (isoString) {
    return formatDatePT(isoString);
  } else {
    const now = new Date();
    const target = new Date("2026-07-01T06:59:59Z");
    return source === "purchased" ? "" : (now < target ? formatDatePT("2026-07-01T06:59:59Z") : "");
  }
}